import { Routes } from '@angular/router';

const adminCmsModule = () => import('./admin-cms.module').then((m) => m.AdminCmsModule);

export const adminCmsRoutes: Routes = [
  {
    path: 'admin-cms',
    loadChildren: adminCmsModule,
    data: {
      enum: 'ADMIN_CMS',
      children: [],
    },
  },
];
